import type { ShopDetailModel } from '@/model/shop';
import { resolveAccessibleShopIds } from '@/constants/auth';

export const SELECTED_SHOP_KEY = 'table_manage_selected_shop';

export const readSelectedShop = (): number | undefined => {
  try {
    const shopId = Number(localStorage.getItem(SELECTED_SHOP_KEY));
    return Number.isSafeInteger(shopId) && shopId > 0 ? shopId : undefined;
  } catch (error) {
    console.warn('读取餐厅选择失败:', error);
    return undefined;
  }
};

export const cacheSelectedShop = (shopId: number | undefined): void => {
  if (!shopId) return;
  try {
    localStorage.setItem(SELECTED_SHOP_KEY, String(shopId));
  } catch (error) {
    console.warn('保存餐厅选择失败:', error);
  }
};

export const restoreSelectedShop = (
  shops: Pick<ShopDetailModel, 'shopId'>[],
  roles?: readonly string[],
): number | undefined => {
  const accessibleShopIds = roles ? resolveAccessibleShopIds(roles) : null;
  const visibleShops = accessibleShopIds
    ? shops.filter((shop) => accessibleShopIds.includes(Number(shop.shopId)))
    : shops;
  const cached = readSelectedShop();
  const selected = visibleShops.find((shop) => Number(shop.shopId) === cached) || visibleShops[0];
  const shopId = selected ? Number(selected.shopId) : undefined;
  cacheSelectedShop(shopId);
  return shopId;
};
